/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceDesktopXL24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceDesktopXL24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 4C5.44772 4 5 4.44772 5 5V14C5 14.5523 5.44771 15 6 15H10V18H7.5V19H17.5V18H15V15H19C19.5523 15 20 14.5523 20 14V5C20 4.44772 19.5523 4 19 4H6ZM11 18H14V15H11V18ZM6 5L19 5V14H6V5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceDesktopXL24Icon.tags = [
  'computer',
  'monitor',
  'desktop',
  'display',
  'screen',
];

DeviceDesktopXL24Icon.category = 'General Icons';

DeviceDesktopXL24Icon.iconSize = 24;
